import { Badge, Button } from "reactstrap";

export const PettyCashBillListHeader = ({
  handleAddNewClick,
  handleRefresh,
  total,
  isRefetching
}) => {
  return (
    <div className="d-flex align-items-center mb-3">
      <h5 className="mb-0 mt-3 flex-grow-1">
        Total Bills <Badge color="info">{total ?? 0}</Badge>
      </h5>

      <div className="flex-shrink-0">
        <Button color="primary" onClick={handleAddNewClick}>
          Create Bill
        </Button>
        <Button color="light" onClick={handleRefresh} className="ms-1">
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>
      </div>
    </div>
  );
};